<template>
  <div>
    <div class="wpcm-custm-amt-before-title">
      <!-- <slot name="before_title"></slot> -->
      <!-- <h3 v-if="title" class="wpcm-custm-amt-title">{{ title }}</h3> -->
    </div>
    <div class="wpcm-custom-amt-box-container">
      <slot name="before_box"></slot>
      <!-- Custom amount input for regular donations -->
      <div class="wpcm-custm-amt-box" v-if="custom_amount">
        <span v-if="symbol" class="wpcm-symbl-prefix">{{ getSymbol() }}</span>
        <input 
          v-model.number="store.amount"
          @input="updateAmount($event)"
          @keypress="isNumber"
          :placeholder="
            strings
              ? strings.donation_amount
              : 'Custom Amount'
          "
        />
        <slot name="in_box"></slot>
      </div>
      
      <!-- Display amount for product donations -->
      <!-- <div class="wpcm-product-amt-display" v-else-if="display_amount">
        <span v-if="symbol" class="wpcm-symbl-prefix">{{ getSymbol() }}</span>
        <span class="wpcm-product-amount">{{ convertAmount(display_amount) }}</span>
        <slot name="in_box"></slot>
      </div> -->
    </div>
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
import { watch, onMounted, computed } from 'vue';
import { useDonationFormsStore } from '../store';
import { ElNotification } from 'element-plus';

const store = useDonationFormsStore();
const props = defineProps({
  custom_amount: Boolean,
  title: String,
  symbol: String,
  symbols: Object,
  strings: Object,
  display_amount: Number,
  min_donation_amount: Number,
  max_donation_amount: Number,
  show_min_max_donation: Boolean,
  post_type: String
});

const lifeline_donation = globalThis.lifeline_donation;
const _ = globalThis._;

const getSymbol = () => {
  return props.symbols?.[store.currency] ?? props.symbol;
};

// Currency conversion function
const convertAmount = (amount: number) => {
  if (!amount || !lifeline_donation?.exchange_rates) {
    return amount;
  }
  
  const currentCurrency = store.currency;
  const exchangeRate = _.get(lifeline_donation.exchange_rates, currentCurrency);
  
  if (exchangeRate) {
    return (amount * exchangeRate).toFixed(2);
  }
  
  return amount;
};

const isNumber = (evt: KeyboardEvent) => {
  const charCode = evt.which || evt.keyCode;
  if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
    evt.preventDefault();
  }
};

const updateAmount = (event: Event) => {
  const target = event.target as HTMLInputElement;
  if (target.value) {
    store.amount = parseFloat(target.value);
  } else {
    store.amount = null; // Ensure the amount is null if the input is empty
  }
};

onMounted(() => {
  if (props.display_amount && !props.custom_amount) {
    // For product donations, set the amount to the display amount
    store.amount = props.display_amount;
  } else {
    // For regular donations, start with null
    store.amount = null;
  }
});

// Watch for currency changes to update the display amount
watch(() => store.currency, (newCurrency) => {
  if (props.display_amount && !props.custom_amount) {
    // Update the store amount with the converted value when currency changes
    const convertedAmount = convertAmount(props.display_amount);
    store.amount = typeof convertedAmount === 'string' ? parseFloat(convertedAmount) : convertedAmount;
  }
});

// watch(() => store.amount, (val) => {
//   if (props.show_min_max_donation) {
//     if (['cause', 'wp_commerce_forms'].includes(props.post_type)) {
//       if (val > props.max_donation_amount) {
//         store.amount = props.max_donation_amount;
//         ElNotification({
//           title: 'Error',
//           message: `Amount should be less than ${props.max_donation_amount}`,
//           type: 'error',
//           duration: 5000,
//           showClose: true
//         });
//       }
//       if (val < props.min_donation_amount) {
//         store.amount = props.min_donation_amount;
//         ElNotification({
//           title: 'Error',
//           message: `Amount should be greater than ${props.min_donation_amount}`,
//           type: 'error',
//           duration: 5000,
//           showClose: true
//         });
//       }
//     }
//   }
// });
</script>

<style scoped>
.wpcm-product-amt-display {
  display: flex;
  align-items: center;
  padding: 15px;
  background-color: #f8f9fa;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  margin-bottom: 15px;
}

.wpcm-symbl-prefix {
  font-size: 18px;
  font-weight: bold;
  color: #495057;
  margin-right: 8px;
}

.wpcm-product-amount {
  font-size: 24px;
  font-weight: bold;
  color: #28a745;
  flex-grow: 1;
}
</style>